import { FC, useMemo } from "react";
import styled from "styled-components";

import { useSelectItemsTranslate } from "@ryde/redux";
import {
  ComplaintStatusEnum,
  IStyledAttributes,
  NO_VALUE_DISPLAY,
  useIsMobile,
} from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

import {
  IStatusIndicatorComplaintControl,
  StatusIndicatorComplaintConst,
} from "../../common";

interface IComplaintStatusCell {
  status: ComplaintStatusEnum;
}

const ComplaintStatusCellStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "complaint-status-cell",
})<IStatusIndicatorComplaintControl>`
  width: 80px;
  height: 24px;
  background-color: ${props => props.$bgColor};
  border-inline-start: 2px solid ${props => props.$leftColor};
  color: ${props => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border-radius: 3px;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 35px;
  }
`;

export const ComplaintStatusCell: FC<IComplaintStatusCell> = ({ status }) => {
  const info = StatusIndicatorComplaintConst[status || ComplaintStatusEnum.New];
  const { translateLabel } = useSelectItemsTranslate();
  const { isMobile } = useIsMobile();
  const statusText = useMemo(() => {
    if (!status || !info?.$translateKey) {
      return NO_VALUE_DISPLAY;
    }

    const text = translateLabel(info.$translateKey) || "";

    if (!isMobile) {
      return text;
    }

    return text.at(0) || "";
  }, [info?.$translateKey, isMobile, status, translateLabel]);

  return (
    <ComplaintStatusCellStyled {...info}>
      {statusText}
    </ComplaintStatusCellStyled>
  );
};
